
import React, { Component } from 'react';

import { getURLWithoutParams } from '../../base/connection';
import { isMobileBrowser } from '../../base/environment/utils';
import { translate } from '../../base/i18n';
import { connect } from '../../base/redux';
import { getBrandingColorPalette } from '../../base/styles';
import { styleDeeplinking } from '../../deep-linking/components/styleWeb';
import { fetchCustomBrandingData } from '../../dynamic-branding';
import { RecentList } from '../../recent-list';
import { Footer } from '../../welcome/components/Footer';
import Tabs from '../../welcome/components/Tabs';
import { styleJoin } from '../style';

import { Header } from './Header';


declare var interfaceConfig : Object;

type Props = {
    locationURL: ?Object,
    _fetchCustomBrandingData: Function,
    _recentListEnabled: boolean,
    t: Function
}

type State = {
    joinMeeting: ?string,
    selectedTab: number,
}

/**
 * The Web container rendering the welcome page.
 *
 * @augments joinMeeting
 */
class joinMeeting extends Component <Props, State> {

    /**
    * The Web constructor rendering the welcome page.
    *
    */
    constructor() {
        super();
        this.state = {
            joinMeeting: '',
            selectedTab: 0

        };
        this.textInput = React.createRef();
        this._onTabSelected = this._onTabSelected.bind(this);
        this._onSubmit = this._onSubmit.bind(this);
    }

    /**
     * Implements React's {@link Component#componentDidMount()}. Invoked
     * immediately after this component is mounted.
     *
     * @inheritdoc
     * @returns {void}
     */
    componentDidMount() {
        this.props._fetchCustomBrandingData();

        if (document.body) {
            document.body.style.overflowY = 'scroll';
        }
        if (document && document.body) {
            const link2 = document.createElement('link');

            link2.href = 'static/assets/vendor/bootstrap/css/bootstrap.min.css';
            link2.rel = 'stylesheet';
            link2.id = 'link2Style1';
            document.body.appendChild(link2);
            const link = document.createElement('link');

            link.href = '/static/assets/css/style1.css';
            link.rel = 'stylesheet';
            link.id = 'linkStyle1';
            document.body.appendChild(link);

            const script = document.createElement('script');

            script.src = '/static/assets/js/main.js';
            script.id = 'mainJS';
            script.async = true;
            document.body.appendChild(script);
        }
        const ele = document.getElementById('preloader');
        const eleJoinContainer = document.getElementById('container');

        if (ele) {
            ele.style.background = '#4b6790';

            setTimeout(() => {
                ele.style.opacity = '0';
                ele.style.zIndex = '0';
                eleJoinContainer.style.margin = 'auto';
                eleJoinContainer.style.zIndex = '10';
                setTimeout(() => {
                    ele.style.display = 'none';
                }, 2000);
            }, 1500);
        }
        const { locationURL } = this.props;

        if (locationURL) {
            const urlwithout = getURLWithoutParams(locationURL);

            window.history.replaceState(
                history.state,
                (document && document.title) || '',
                urlwithout);
        }

    }

    /**
     * Implements React's {@link Component#componentWillUnmount()}. Invoked
     * immediately after this component is mounted.
     *
     * @inheritdoc
     * @returns {void}
     */
    componentWillUnmount() {
        const styleBootstrap = document.getElementById('link2Style1');
        const styleCss = document.getElementById('linkStyle1');
        const scriptMain = document.getElementById('mainJS');

        if (styleBootstrap) {
            styleBootstrap.remove();
        }
        if (styleCss) {
            styleCss.remove();
        }
        if (scriptMain) {
            scriptMain.remove();
        }
    }


    _onSubmit: (e: any) => void;

    /**
     * Handler for the join button.
     *
     * @param {any} e - The synthetic event.
     * @returns {void}
     */
    _onSubmit(e) {
        e.preventDefault();
        const getRoomValue = this.textInput.current.value;

        if (getRoomValue) {

            const res = (/(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%.+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)/g).test(getRoomValue);


            if (res) {

                const href = window.location;

                return href.replace(getRoomValue);

                // window.location = href.replace(/testing\/.*$/, "testing/"+$('#roomName').val());

            }

            return window.location.replace(`/${getRoomValue}`);

        }
    }

    /**
     * Callback invoked when the desired tab to display should be changed.
     *
     * @param {number} tabIndex - The index of the tab within the array of
     * displayed tabs.
     * @private
     * @returns {void}
     */
    _onTabSelected(tabIndex) {
        this.setState({ selectedTab: tabIndex });
    }

    /**
     * Renders tabs to show previous meetings and upcoming calendar events. The
     * tabs are purposefully hidden on mobile browsers.
     *
     * @returns {ReactElement|null}
     */
    _renderTabs() {
        if (isMobileBrowser()) {
            return null;
        }

        const { _recentListEnabled, t } = this.props;

        const tabs = [];


        if (_recentListEnabled) {
            tabs.push({
                label: t('welcomepage.recentList'),
                content: <RecentList />
            });
        }

        if (tabs.length === 0) {
            return null;
        }


        return (
            <Tabs
                onSelect = { this._onTabSelected }
                selected = { this.state.selectedTab }
                tabs = { tabs } />);
    }

    /**
     * Implements React's {@link Component#render()}.
     *
     * @inheritdoc
     * @returns {ReactElement|null}
     */
    render() {
        const { t } = this.props;
        const joinMeetingContainerStyle = {
            marginTop: '65px',
            marginBottom: '34px',
            backgroundColor: getBrandingColorPalette(interfaceConfig)?.primary };
        const joinMeetingButtonStyle = {
            pointerEvents: 'all',
            cursor: 'pointer',
            backgroundColor: getBrandingColorPalette(interfaceConfig)?.secondary
        };

        return (<>
            <Header prejoin = { true } />
            <div id = 'preloader'>
                <div
                    className = 'box-preloader'
                    id = 'loader1' />
                <div
                    className = 'box-preloader'
                    id = 'loader2' />
                <div
                    className = 'box-preloader'
                    id = 'loader3' />
                <div
                    className = 'box-preloader'
                    id = 'loader4' />
                <div
                    className = 'box-preloader'
                    id = 'loader5' />
            </div>
            <div
                className = 'container'
                id = 'container'>
                <div
                    className = 'container-fluid dark-bg'
                    id = 'join-meeting-container'
                    style = { joinMeetingContainerStyle }>
                    <div className = 'row'>
                        <div className = 'col-md-12 col-sm-12'>
                            <div>
                                <h4
                                    style = { styleJoin.h4Style }>
                                    {t('prejoin.joinAMeeting')}
                                </h4>
                            </div>
                        </div>
                        <div className = 'col-md-12 col-sm-12'>
                            <form
                                className = 'join-meeting-form'
                                id = 'becomepassengerForm'
                                noValidate = { true }
                                onSubmit = { this._onSubmit } >
                                <input
                                    className = 'form-control2'
                                    id = 'roomname'
                                    name = 'roomname'
                                    placeholder = { t('prejoin.enterMeetingIdOrLink') }
                                    ref = { this.textInput }
                                    required = { true }
                                    style = { styleJoin.inputStyle }
                                    type = 'text' />
                                <button
                                    className = 'new-button disabled'
                                    style = { joinMeetingButtonStyle }
                                    type = 'submit'>{t('prejoin.joinAMeeting')}</button>
                            </form>
                            <h6
                                className = 'recent-meeting'
                                style = { styleJoin.h6Style }>{t('prejoin.recentMeetings')}:</h6>
                            { this._renderTabs() }
                        </div>
                    </div>
                </div>
            </div>
            <Footer
                prejoin = { true }
                style = { styleDeeplinking(interfaceConfig).width100 } />
        </>
        );
    }
}


/**
 * Maps (parts of) the redux state to the React {@code Component} props of
 * {@code AbstractWelcomePage}.
 *
 * @param {Object} state - The redux state.
 * @protected
 * @returns {Props}
 */
export function _mapStateToProps(state: Object) {
    const participants = state['features/base/participants'];
    const { userDetails } = state['features/base/mtApi'];
    const participant = participants.filter(i => i.id === 'local');
    const { locationURL } = state['features/base/connection'];

    return {
        _enableInsecureRoomNameWarning: state['features/base/config'].enableInsecureRoomNameWarning || false,
        _moderatedRoomServiceUrl: state['features/base/config'].moderatedRoomServiceUrl,
        _recentListEnabled: interfaceConfig.RECENT_LIST_ENABLED,
        _room: state['features/base/conference'].room,
        _settings: state['features/base/settings'],
        _localParticipant: participant,
        userDetails,
        locationURL
    };
}

const mapDispatchToProps = {
    _fetchCustomBrandingData: fetchCustomBrandingData
};

export default translate(connect(_mapStateToProps, mapDispatchToProps)(joinMeeting));
